import { render } from "./FlagUA.vue?vue&type=template&id=0bf7a3f6"
import script from "./FlagUA.vue?vue&type=script&lang=js"
export * from "./FlagUA.vue?vue&type=script&lang=js"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__